import { AiOutlineContacts, AiOutlineDatabase, AiOutlineFieldTime, AiOutlineFile, AiOutlineMobile } from "react-icons/ai";

//Page Title: Power BI Integration
export const powerbiData = [
    {
      title: " Reports for Employees / Microsoft 365 Users",
      video: true,
      videoId: "FNhbdsRQnqo",
      videoType: "youtube",
      icon: <AiOutlineContacts className='text-white fs-5' />
    },
    {
      title: "Reports for your Customers",
      video: true,
      videoId: "sYFuPDG8pV0",
      videoType: "youtube",
      icon: <AiOutlineFile className='text-white fs-5' />
    },
    {
      title: "Row Level Security / Data Access Control",
      video: false,
      videoId: "",
      videoType: "",
      icon: <AiOutlineDatabase className='text-white fs-5' />
    },
    {
      title: "Real-Time Data Updates",
      video: false,
      videoId: "",
      videoType: "",
      icon: <AiOutlineFieldTime className='text-white fs-5' />
    },
    {
      title: "Mobile & Web Layout Rendering",
      video: false,
      videoId: "",
      videoType: "",
      icon: <AiOutlineMobile className='text-white fs-5' />
    }
]